import React, {useState} from 'react';

const DeleteReviewersModal = ({removeReviewers, reviewerType}) => {

  return (
    <div id={"delete-reviewers-reveal-modal"} className="reveal-modal middling" data-reveal>
      <div className="modal-body">
        <div className="modal-close">
          <a href='#' className='cancel-modal'>
            <img src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>
        <div className="modal-content">
          <div className="row">
            <div className="large-12 columns">
              <h4>Remove selected {reviewerType}s from article?</h4>
              <p><strong>Warning: all {reviewerType} history will be lost forever.</strong></p>
            </div>
          </div>
          <div className="modal-footer">
            <a href="#" className="button cancel-modal">Cancel</a>
            <button className="button alert" onClick={removeReviewers}>Remove {reviewerType}s</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteReviewersModal;